.driveUpAccess {
  position: relative;
  width: 41px;
  flex-grow: 1;

  img {
    width: 100%;
    z-index: 2;
    position: relative;
  }

  svg {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 1;
  }
}
